module.exports = __webpack_public_path__ + "static/media/stopIconSemSobra.73763393.svg";